import type React from 'react';

type Props = {
  children: React.ReactNode;
};

const DefaultCell = ({ children }: Props) => {
  return (
    <div className="flex h-full min-h-7.75 w-full items-center justify-start gap-2 pt-0">
      {children}
    </div>
  );
};
export { DefaultCell };
